import { createTanstackEndpoint } from "../utils/create-endpoint"
import { endpoints } from "./endpoints"

const endpoint = endpoints.crossAppToken.create

export const createCrossAppToken = createTanstackEndpoint(endpoint, "POST")
